<template>
  <v-container>
    <p>Loading...</p>
  </v-container>
</template>

<script>
export default {
  mounted: function () {
    // Redirect the user based on their role
    if (!this.$auth.check()) {
      this.$router.push('/login')
    } else {
      let role = this.$auth.user().roles

      switch (role) {
        case 'church-staff':
          this.$router.push('/manage/church')
          break
        default:
          this.$router.push('/')
          break
      }
    }
  }
}
</script>
